// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__CdFtn","active":"Tab_active__VepfM"};